export function createCeco() {
  return {
    Clave: '',
    Nombre: '',
    Numero: '',
    Clave2: '',
    EmpresaId: 0,
    EsActivo: true,
    DimensionNum: 0,
    PadreClave: '',
    ClaveErp: ''
  };
}
